<template>
    <a
        v-if="showImage"
        :href="model.Link.Url"
    >
        <img
            :src="model.Image.Url"
            :alt="model.Image.Alt"
        >
    </a>
</template>

<script>
export default {
    name: 'FooterLogoImage',
    props: {
        model: {
            type: Object,
            default() {
                return {
                    Link: {
                        Url: ''
                    },
                    Image: {
                        Url: '',
                        Alt: ''
                    }
                };
            }
        }
    },
    computed: {
        showImage() {
            return this.model !== null && this.model.Image !== null && this.model.Image.Url !== '';
        }
    }
};
</script>
